


























import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { IUserDefinedItemSelectBehavior, UserDefinedInformationWindowKinds } from "../../../../../documaker/domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class UserDefinedItemSelectBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IUserDefinedItemSelectBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IUserDefinedItemSelectBehavior) => T, defaultValue: T) => T;
  
  get windowKind(): UserDefinedInformationWindowKinds {
    return this.readPropertyOrDefault(s => s.windowKind, UserDefinedInformationWindowKinds.Normal);
  }

  set windowKind(value: UserDefinedInformationWindowKinds) {
    this.writePropertyWhenValid(s => s.windowKind = value);
  }

  get shouldSelectRow(): boolean {
    return this.readPropertyOrDefault(s => s.shouldSelectRow, true);
  }  

  set shouldSelectRow(value: boolean) {
    this.writePropertyWhenValid(s => s.shouldSelectRow = value);
  }

  windowKindOptions: StandardOption<number>[] = [
    new StandardOption<number>("通常", UserDefinedInformationWindowKinds.Normal),
    new StandardOption<number>("C-Scan紹介元一覧", UserDefinedInformationWindowKinds.CScanIntroductionOrigin),
  ];
}
